export abstract class BaseResourceModel {
    id?: number;
    signature?: any;
    model?: any;

    /** Pivot de arquivo: existe linha global (client_id null) com archive=1 */
    archive_is_global?: boolean;
}
